<template>
    <modal name="member-out-modal" class="member-out-modal"
           :width="'30%'"
           :height="'auto'"
           @opened = "opened"
    >
        <div class="keymodal_title">
      <span class="keymodal_title_txt">
      </span>
          <div class="out_title">회원 탈퇴처리</div>

            <!-- <button class="keymodal_title_btn" @click="closeModal">
                <i class="el-dialog__close el-icon el-icon-close"></i>
            </button> -->
        </div>
        <div class="pb30">
            <div class="c_table_wrap pt40 text_center">
                <div class="">
                    <p class="fs16">정말 회원을 강제탈퇴 처리 하시겠습니까?</p>
                    <p class="fs16">탈퇴처리 이후엔 복구가 불가능합니다.</p>
                </div>
                <div class="text_left out_table">
                    <el-select class="w_100 mt15"
                            v-model="moc_idx"
                    >
                        <el-option
                                label="탈퇴사유를 입력해주세요"
                                value=""
                        >
                        </el-option>
                        <el-option
                                v-for="(item, index) in outList"
                                :key="index"
                                :label="item.moc_category"
                                :value="item.moc_idx"
                        >
                        </el-option>
                    </el-select>
                    <div class="input_error">{{validation.firstError('moc_idx') }}</div>
                    <el-input class=" mt3" v-model="mo_reason" v-if="moc_idx === 3"></el-input>
                    <div class="input_error"  v-if="moc_idx === 3">{{validation.firstError('mo_reason') }}</div>
                    <el-input class=" mt3" type="password" v-model="mb_password" placeholder="관리자 비밀번호"></el-input>
                    <div class="input_error">{{validation.firstError('mb_password') }}</div>

                </div>
            </div>
            <div class="text_center pt50">
                <el-button type="info" class="out_btn" @click="closeModal()">취소</el-button>
                <el-button type="info" class="out_btn" @click="memberOut()">확인</el-button>
            </div>
          </div>
    </modal>
</template>

<script>
    import VuxAlert from '@/mixins/alertMixins';
    import AuthValidator from "@/mixins/validators/AuthValidator";

    let params = {};
    export default {
        name: "MemberOutModal",
        mixins: [ VuxAlert ,AuthValidator],
        props: {
            getObj: {}
        },
        data() {
            return {
                outList : []
            }
        },
        methods: {
            opened() {

                params = {moc_type : 'admin' , isad : 1}
                this.$api.$member.getMemberOutCategory(params).then( res => res.Data.Result).then(res => {
                    if(res.Info.status){
                        this.outList = res.List;
                    }
                });

            },
            memberOut() {
                let validationArray = ['moc_idx','mb_password'];
                if(this.moc_idx === 3){
                    validationArray.push('mo_reason');
                }
                this.$validate(validationArray).then(async (success) => {
                    if(success) {
                        console.log(this.moc_idx,);
                            params = {
                                m_type: 'admin',
                                moc_idx : this.moc_idx,
                                mb_no : this.getObj.mb_no,
                                mb_password : this.mb_password,
                                mo_reason : this.mo_reason
                            }

                            this.$api.$member.deleteMember(params).then( res => res.Data.Result).then(res => {
                                if(res.Info.status){
                                    this.createAlert({
                                        title: "알림",
                                        content: "탈퇴 완료.",
                                        btnText: "확인",
                                        hide: () => {
                                            this.$router.push("/member");
                                            this.closeModal();
                                        }
                                    });
                                }else{
                                    if(res.Info.Type === -200){
                                        this.createAlert({
                                            title: '',
                                            content: "비밀번호가 틀렸습니다",
                                            btnText: '확인',
                                            hide: () => {
                                                this.closeModal();
                                            }
                                        });
                                    }else{
                                        this.createAlert({
                                            title: '',
                                            content: "탈퇴 실패",
                                            btnText: '확인',
                                            hide: () => {
                                                this.closeModal();
                                            }
                                        });
                                    }
                                }
                            })
                    }else{
                        this.errorAlert('입력값을 확인해주세요.')
                    }
                });
            },
            closeModal() {
                this.$modal.hide("member-out-modal")
            },
        }
    }
</script>

<style scoped>

</style>
